import api from '../library/axios';

export default {
  getList(page, search) {
    return api({
      method: 'get',
      url: '/api/notif/blogs/list',
      params: {
        page,
        search,
      },
    });
  },
  getDetail(blog_id) {
    return api({
      method: 'get',
      url: `/api/notif/blogs/${blog_id}/detail`,
    });
  },
  create(payload) {
    return api({
      method: 'post',
      url: '/api/notif/blogs/create',
      data: payload,
    });
  },
  save(blog_id, payload) {
    return api({
      method: 'patch',
      url: `/api/notif/blogs/${blog_id}/edit`,
      data: payload,
    });
  },
  delete(blog_id) {
    return api({
      method: 'delete',
      url: `/api/notif/blogs/${blog_id}/delete`,
    });
  },
  publish(blog_id) {
    return api({
      method: 'patch',
      url: `/api/notif/blogs/${blog_id}/publish`,
    });
  },
  unpublish(blog_id) {
    return api({
      method: 'patch',
      url: `/api/notif/blogs/${blog_id}/unpublish`,
    });
  },
  /**
   * WAP-407 lanjutan — upload satu gambar (dipakai untuk kartu opsi poll) dan dapatkan URL-nya.
   *
   * Lewat jalur `uploadHandler` milik wrapper axios, yang memasang header multipart dan
   * melonggarkan batas ukuran body. Diunggah saat berkasnya dipilih, bukan ikut base64 di
   * payload create/edit: lima gambar dalam satu submit akan jadi payload beberapa MB, dan
   * preview langsung jauh lebih enak daripada baru ketahuan setelah Save.
   */
  uploadAttachment(file, uploadHandler = () => {}) {
    const data = new FormData();
    data.append('file', file);
    return api({
      url: '/api/notif/blogs/attachment',
      data,
      uploadHandler,
    });
  },
  // WAP-407 — rekap jawaban announcement ber-CTA (rsvp maupun poll). `params.response`
  // menyaring ke satu jawaban: nilai RSVP, atau key opsi poll.
  getResponses(blog_id, params) {
    return api({
      method: 'get',
      url: `/api/notif/blogs/${blog_id}/responses`,
      params,
    });
  },
  // Balikannya `{ secure_url }` ke file CSV di R2, bukan file-nya langsung.
  exportResponses(blog_id) {
    return api({
      method: 'get',
      url: `/api/notif/blogs/${blog_id}/responses/export`,
    });
  },
};
